import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-pharmacist-national-id',
  imports: [ReactiveFormsModule],
  templateUrl: './pharmacist-national-id.html',
  styleUrl: './pharmacist-national-id.scss',
})
export class PharmacistNationalId {
  pharmacyForm = input.required<FormGroup>();
}
